import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PasswordChecklist from "react-password-checklist";
import './Login.css';

function SignUp() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isPasswordValid, setIsPasswordValid] = useState(false);
  const [showPasswordChecklist, setShowPasswordChecklist] = useState(false);

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  // Get query parameters for OAuth flow
  const params = new URLSearchParams(window.location.search);
  const redirectUri = params.get('redirect_uri');
  const state = params.get('state');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSuccessMessage('');

    // Validate email
    if (!validateEmail(email)) {
      setErrorMessage('Please enter a valid email address');
      return;
    }

    // Validate password
    if (!isPasswordValid) {
      setErrorMessage('Please ensure all password requirements are met');
      return;
    }

    setIsLoading(true);

    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/native/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          FirstName: firstName,
          LastName: lastName,
          Email: email,
          Password: password,
          RedirectUri: redirectUri,
          State: state
        }),
      });

      const data = await response.json();

      if (response.ok) {        
        if (data.redirectUri) {

          localStorage.setItem('authToken', data.accessToken);
          localStorage.setItem('refreshToken', data.refreshToken);

          if (data.state) {
            await sendAuthToken(data.accessToken, data.redirectUri, data.state);
          } else {
            localStorage.setItem('communityIFrameUrl', data.redirectUri);
            navigate('/community');
          }
        } else {
          setSuccessMessage('Sign up successful! You can now log in.');
          // Clear form
          setFirstName('');
          setLastName('');
          setEmail('');
          setPassword('');
          setConfirmPassword('');
          setIsLoading(false);
        }
      } else {
        setErrorMessage(data.message || 'Failed to create account. Please try again.');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error during signup:', error);
      setErrorMessage('An unexpected error occurred. Please try again later.');
      setIsLoading(false);
    }
  };

  const sendAuthToken = async (authToken, redirectUri, state) => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/oauth/getauthcode`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          RedirectUri: redirectUri,
          State: state
        })
      });

      if (response.ok) {
        const data = await response.json();
        window.location.href = data.redirect_url;
      } else {
        const errorData = await response.json();
        setErrorMessage('Authorization failed. Please try again later.');
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Error during authorization:', error);
      setIsLoading(false);
    }
  };

  return (
    <div className="login-container">
      {successMessage ? (
        <div className="login-form">
          <img src="https://afterschoolhq.com/Assets/img/ahq-logo-2-1-1.png" alt="Logo" className="login-logo" />
          <div className="success-message">{successMessage}</div>
          <a href="#" className="reset-link" onClick={(e) => {
            e.preventDefault();
            navigate('/login');
          }}>Return to Login</a>
        </div>
      ) : (
        <form className="login-form" onSubmit={handleSubmit}>
          <img src="https://afterschoolhq.com/Assets/img/ahq-logo-2-1-1.png" alt="Logo" className="login-logo" />
          
          <input
            type="text"
            placeholder="First Name"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
            required
          />
          
          <input
            type="text"
            placeholder="Last Name"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
            required
          />
          
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setShowPasswordChecklist(e.target.value.length > 0 || confirmPassword.length > 0);
            }}
            required
          />
          
          <input
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => {
              setConfirmPassword(e.target.value);
              setShowPasswordChecklist(e.target.value.length > 0 || password.length > 0);
            }}
            required
          />

          {showPasswordChecklist && (
            <div className="password-checklist">
              <PasswordChecklist
                rules={["minLength","specialChar","number","capital","match"]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                onChange={(isValid) => setIsPasswordValid(isValid)}
                messages={{
                  minLength: "At least 8 characters long",
                  specialChar: "Contains a special character",
                  number: "Contains a number",
                  capital: "Contains an uppercase letter",
                  match: "Passwords match",
                }}
              />
            </div>
          )}

          {errorMessage && <div className="error-message">{errorMessage}</div>}
          
          <button type="submit" disabled={isLoading || !isPasswordValid}>
            {isLoading ? 'Creating Account...' : 'Sign Up'}
          </button>
          
          <a href="#" className="reset-link" onClick={(e) => {
            e.preventDefault();
            navigate('/login');
          }}>Already have an account? Log in</a>
        </form>
      )}
    </div>
  );
}

export default SignUp; 